import {Youtube} from "./Youtube";
import simpleParallax from "simple-parallax-js";

export class Home {
	
	static VIDEO_MV_PC = {
		id: 'Fu931oDBMik',
		width: 1920,
		height: 1138
	};
	static VIDEO_MV_SP = {
		id: 'xAI05aOPoA4',
		width: 1128,
		height: 1920
	};
	
	constructor(app) {
		this.app = app;
		this.initVideo();
		this.initAnimation();
		this.initSlider();
	}
	
	initVideo() {
		if(window.isYoutubeAccess){
			this.initYoutube();
		}else{
			this.initMp4();
		}
	}
	
	initMp4(){
		var video = document.querySelector('#mvVideoMp4');
		video.play();
		video.classList.add('is-active');
	}
	
	initYoutube() {
		Youtube.initTag(this.initMvYoutube.bind(this));
	}
	
	initMvYoutube(){
		
		if(app.isSmartPhone()){
			this.videoMv = Home.VIDEO_MV_SP;
		}else{
			this.videoMv = Home.VIDEO_MV_PC;
		}
		
		var player = new YT.Player('mvVideo', {
			videoId: this.videoMv.id,
			autoplay: 1,
			controls: 0,
			modestbranding: 1,
			rel: 0,
			loop: 1,
			events: {
				'onReady': e =>{
					$(window).trigger('resize');
					e.target.mute();
					e.target.playVideo();
				},
				'onStateChange': e => {
					if(e.data == YT.PlayerState.ENDED){
						e.target.playVideo();
					}
					if(e.data == YT.PlayerState.PLAYING){
						document.getElementById('mvVideo').classList.add('is-ready');
					}
				}
			}
		});
		
		$(window).resize((e)=>{
			Youtube.cover('.h-mv__video',this.videoMv.width ,this.videoMv.height);
		});
	}
	
	initAnimation(){
		var elements = $('[data-aos="split-text"]');
		this.app.initTextAnimation(elements);
		var images = document.querySelectorAll('[data-para]');
		new simpleParallax(images, {
			overflow: true,
			scale: 1.3
		});
		
	}
	
	initSlider() {
		
		var bannerSlick = $('.h-banner__list');
		bannerSlick.slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite:true,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 2000,
			speed: 1200,
			cssEase: 'cubic-bezier(0.455, 0.030, 0.120, 0.975)',
			responsive:[
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						centerMode:true
					}
				}
			]
		});
		
		return;
	}
}
